
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/regulamin",
      function () {
        return require("private-next-pages/regulamin.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/regulamin"])
      });
    }
  